/** Set by the API. Not the session token. The token cookie is HttpOnly. */
export const SIGNED_IN_COOKIE = 'complyedge-signed-in';

export const isLocalDevHost = (): boolean => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const setCookie = (name: string, value: string, days: number, domain?: string) => {
  if (!value) {
    throw new Error(`Cannot set empty value for cookie: ${name}`);
  }

  const encodedName = encodeURIComponent(name);
  const encodedValue = encodeURIComponent(value);

  let expires = '';
  if (days > 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  let cookieString = `${encodedName}=${encodedValue}${expires}; path=/; SameSite=Lax`;

  // Secure + domain are only valid off local hosts. Setting domain=<prod-host>
  // while on localhost/127.0.0.1 produces a cookie the browser silently rejects
  // (domain mismatch), so suppress both there.
  if (!isLocalDevHost()) {
    cookieString += '; Secure';
    if (domain) {
      cookieString += `; domain=${domain}`;
    }
  }

  document.cookie = cookieString;
};

export const getCookie = (name: string): string | null => {
  const encodedName = encodeURIComponent(name) + '=';
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(encodedName)) {
      return decodeURIComponent(trimmed.substring(encodedName.length));
    }
  }

  return null;
};

export const deleteCookie = (name: string, domain?: string) => {
  const encodedName = encodeURIComponent(name);
  const expired = `${encodedName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax`;

  // Always clear the host-only cookie (how setCookie writes on local hosts).
  document.cookie = expired;

  // Off local hosts, also clear the Domain= cookie setCookie writes for prod.
  if (!isLocalDevHost() && domain) {
    document.cookie = `${expired}; Secure; domain=${domain}`;
  }
};
